<template>
  <div class="side-page" v-if="visible">
    <div class="side-page-content">
      <h2>Edit Tag</h2>

      <div class="form-group">
        <label for="tagMac">Tag MAC:</label>
        <input id="tagMac" v-model="tagMac" readonly placeholder="Tag MAC" />
      </div>

      <div class="form-group">
        <label for="deviceName">Device Name:</label>
        <input id="deviceName" v-model="deviceName" placeholder="Enter device name" />
      </div>

      <div class="form-group">
        <label for="tagLocation">Tag Location:</label>
        <input id="tagLocation" v-model="tagLocation" placeholder="Enter tag location" />
      </div>

      <div class="form-group">
        <label for="building">Building:</label>
        <input id="building" v-model="building" placeholder="Enter building" />
      </div>

      <div class="form-group">
        <label for="floor">Floor:</label>
        <input id="floor" v-model="floor" placeholder="Enter floor" />
      </div>

      <div class="form-group">
        <label for="assignedZone">Assigned Zone:</label>
        <input id="assignedZone" v-model="assignedZone" placeholder="Enter assigned zone" />
      </div>

      <div class="form-group">
        <label for="deviceType">Device Type:</label>
        <input id="deviceType" v-model="deviceType" placeholder="Enter device type" />
      </div>

      <div class="button-group">
        <button @click="save">Save</button>
        <button @click="close">Cancel</button>
      </div>

      <div class="delete-section">
        <button class="delete-btn" @click="confirmDelete">Delete Tag</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditTag',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    tag: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tagMac: this.tag.tag_mac || '',
      deviceName: this.tag.devicename || '',
      tagLocation: this.tag.taglocation || '',
      building: this.tag.building || '',
      floor: this.tag.floor || '',
      assignedZone: this.tag.assignedzone || '',
      deviceType: this.tag.devicetype || '',
    };
  },
  watch: {
    tag: {
      handler(newTag) {
        if (newTag) {
          this.tagMac = newTag.tag_mac || '';
          this.deviceName = newTag.devicename || '';
          this.tagLocation = newTag.taglocation || '';
          this.building = newTag.building || '';
          this.floor = newTag.floor || '';
          this.assignedZone = newTag.assignedzone || '';
          this.deviceType = newTag.devicetype || '';
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    save() {
      const tagData = {
        tag_mac: this.tagMac,
        devicename: this.deviceName,
        taglocation: this.tagLocation,
        building: this.building,
        floor: this.floor,
        assignedzone: this.assignedZone,
        devicetype: this.deviceType,
        company: localStorage.getItem('company')
      };

      console.log('Saving tag data:', tagData);
      this.$emit('save', tagData);
    },
    close() {
      this.$emit('close');
    },
    confirmDelete() {
      if (confirm(`정말로 이 태그(${this.tagMac})를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`)) {
        this.$emit('delete', this.tagMac);
      }
    },
  },
};
</script>

<style scoped>
.side-page {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background-color: white;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
  padding: 20px;
  z-index: 1000;
  overflow-y: auto;
  font-family: Arial, sans-serif;
  border-radius: 12px 0 0 12px;
  transition: transform 0.3s ease;
}

h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 20px;
}

label {
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
}

input:focus {
  outline: none;
  border-color: #4e73df;
  box-shadow: 0 4px 12px rgba(78, 115, 223, 0.15);
}

input[readonly] {
  background-color: #f8f9fa;
  color: #666;
  cursor: not-allowed;
}

.button-group {
  margin-top: 30px;
  display: flex;
  gap: 12px;
}

button {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:first-child {
  background-color: #4e73df;
  color: white;
}

button:first-child:hover {
  background-color: #3a5bc7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(78, 115, 223, 0.3);
}

button:last-child {
  background-color: #6c757d;
  color: white;
}

button:last-child:hover {
  background-color: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.delete-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.delete-btn {
  width: 100%;
  padding: 12px 20px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.delete-btn:hover {
  background-color: #c82333;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* 반응형 디자인 - 태블릿 (1200px 이하) */
@media screen and (max-width: 1200px) {
  .side-page {
    width: 350px;
    padding: 16px;
  }
  
  h2 {
    font-size: 22px;
    margin-bottom: 16px;
  }
  
  .form-group {
    margin-bottom: 16px;
  }
  
  label {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  input {
    padding: 10px;
    font-size: 13px;
  }
  
  button {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* 반응형 디자인 - 모바일 (768px 이하) */
@media screen and (max-width: 768px) {
  .side-page {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    padding: 16px;
    right: 0;
    top: 0;
    box-shadow: none;
    background-color: #f8f9fa;
  }
  
  h2 {
    font-size: 20px;
    margin-bottom: 20px;
    text-align: center;
    background: white;
    margin: -16px -16px 20px -16px;
    padding: 16px;
    border-radius: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    background: white;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  
  label {
    font-size: 13px;
    margin-bottom: 8px;
    color: #555;
  }
  
  input {
    padding: 12px;
    font-size: 14px;
    border: 1px solid #ddd;
  }
  
  .button-group {
    margin-top: 20px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    padding: 16px 0;
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-right: 16px;
    border-top: 1px solid #e0e0e0;
  }
  
  button {
    padding: 14px 20px;
    font-size: 14px;
    font-weight: 600;
  }
}

/* 반응형 디자인 - 작은 모바일 (480px 이하) */
@media screen and (max-width: 480px) {
  .side-page {
    padding: 12px;
  }
  
  h2 {
    font-size: 18px;
    margin: -12px -12px 16px -12px;
    padding: 12px;
  }
  
  .form-group {
    padding: 12px;
    margin-bottom: 10px;
  }
  
  label {
    font-size: 12px;
    margin-bottom: 6px;
  }
  
  input {
    padding: 10px;
    font-size: 13px;
  }
  
  .button-group {
    margin-top: 16px;
    gap: 8px;
    margin-left: -12px;
    margin-right: -12px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  
  button {
    padding: 12px 16px;
    font-size: 13px;
  }
}

/* 큰 화면에서의 최적화 (1600px 이상) */
@media screen and (min-width: 1600px) {
  .side-page {
    width: 450px;
    padding: 24px;
  }
  
  h2 {
    font-size: 26px;
    margin-bottom: 24px;
  }
  
  .form-group {
    margin-bottom: 24px;
  }
  
  label {
    font-size: 15px;
    margin-bottom: 10px;
  }
  
  input {
    padding: 14px 16px;
    font-size: 15px;
  }
  
  .button-group {
    margin-top: 36px;
    gap: 16px;
  }
  
  button {
    padding: 14px 24px;
    font-size: 15px;
  }
}

/* 랜드스케이프 모드 최적화 */
@media screen and (max-width: 768px) and (orientation: landscape) {
  .side-page {
    padding: 12px;
  }
  
  h2 {
    font-size: 18px;
    margin: -12px -12px 16px -12px;
    padding: 12px;
  }
  
  .form-group {
    margin-bottom: 8px;
    padding: 12px;
  }
  
  label {
    font-size: 12px;
    margin-bottom: 4px;
  }
  
  input {
    padding: 8px;
    font-size: 13px;
  }
  
  .button-group {
    margin-top: 16px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid #e0e0e0;
    padding: 12px;
    gap: 12px;
  }
  
  button {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* 접근성 개선 */
@media (prefers-reduced-motion: reduce) {
  .side-page,
  button,
  input {
    transition: none;
  }
  
  button:hover {
    transform: none;
  }
}

/* 다크모드 대응 */
@media (prefers-color-scheme: dark) {
  .side-page {
    background-color: #2d2d2d;
    color: #ffffff;
  }
  
  h2 {
    color: #ffffff;
    border-bottom-color: #404040;
  }
  
  label {
    color: #cccccc;
  }
  
  input {
    background-color: #404040;
    border-color: #555555;
    color: #ffffff;
  }
  
  input[readonly] {
    background-color: #333333;
    color: #888888;
  }
  
  input:focus {
    border-color: #6c8cdf;
    box-shadow: 0 4px 12px rgba(108, 140, 223, 0.15);
  }
  
  .form-group {
    background: #333333;
  }
  
  .button-group {
    background: #2d2d2d;
    border-top-color: #404040;
  }
}
</style> 